module.exports = __webpack_public_path__ + "statics/img/01.c227bcdb.jpg";